import React from 'react';
import { FormField, Select } from '../../../ui/Form';
import type { AccountingLevel } from '../../../../types/accounting-levels';

interface AccountingTypeSelectorProps {
  value: AccountingLevel;
  onChange: (value: AccountingLevel) => void;
}

/**
 * Sélecteur de niveau de comptabilité
 * Les niveaux correspondent à la hiérarchie des Business Units:
 * - single (company): Comptabilité unique au niveau de l'entreprise
 * - multi (branch/pos): Comptabilité multi-niveaux avec succursales et points de vente
 */
export function AccountingTypeSelector({ value, onChange }: AccountingTypeSelectorProps) {
  return (
    <FormField label="Niveau de comptabilité">
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as AccountingLevel)}
        options={[
          { value: 'single', label: 'Entreprise uniquement (Niveau 0)' },
          { value: 'multi', label: 'Multi-niveaux (Entreprise, Succursales, Points de vente)' }
        ]}
      />
    </FormField>
  );
}